import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { userConstants } from '../../constants';
import { userService } from '../../services';
import { RootState } from '../../store';
import { notificationActions } from './notification.actions';
import jwtDecode from 'jwt-decode';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const login =(userName: string, password: string) =>
  async (dispatch: any) => {
    const request = (user: any) => {
      return { type: userConstants.LOGIN_REQUEST, payload: user };
    };
    const success = (user: any) => {
      return { type: userConstants.LOGIN_SUCCESS, payload: user };
    };
    const failure = (error: string) => {
      return { type: userConstants.LOGIN_FAILURE, payload: error };
    };

    try {
      dispatch(request({ userName }));
      const response = await userService.login(userName, password);
      const loggingInTeacherInfo = jwtDecode(response.accessToken);

      // Lưu thông tin người dùng vào localStorage
      localStorage.setItem('userInfo', JSON.stringify(loggingInTeacherInfo));
      dispatch(success(loggingInTeacherInfo));
      dispatch(notificationActions.addNotification('Login Successfully!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      // Không dispatch notification lỗi chung, để màn login tự hiển thị lỗi đỏ
    }
  };


const signup = (user: any) => {
  return (dispatch: any) => {
    dispatch(request(user));

    userService.signup(user).then(
      (user: any) => {
        dispatch(success(user));
        dispatch(notificationActions.addNotification('Sign Up Successfully!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request(user: any) {
    return { type: userConstants.SIGNUP_REQUEST, user };
  }
  function success(user: any) {
    return { type: userConstants.SIGNUP_SUCCESS, user };
  }
  function failure(error: any) {
    return { type: userConstants.SIGNUP_FAILURE, error };
  }
};

const getTeacherById = (id: number) => {
  return (dispatch: any) => {
    dispatch(request(id));

    userService.getById(id).then(
      (teacherInfor: any) => {
        dispatch(success(teacherInfor));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification('getTeacherById() bị lỗi: '+error.toString(), 'DANGER'));
      }
    );
  };

  function request(user: any) {
    return { type: userConstants.SIGNUP_REQUEST, user };
  }
  function success(user: any) {
    return { type: userConstants.SIGNUP_SUCCESS, user };
  }
  function failure(error: any) {
    return { type: userConstants.SIGNUP_FAILURE, error };
  }
};

const logout = () => {
  userService.logout();
  // Xóa thông tin người dùng khỏi localStorage khi đăng xuất
  localStorage.removeItem('userInfo');
  return { type: userConstants.LOGOUT };
};

const fetchCurrentUser = () => {
  return (dispatch: any) => {
    dispatch(request());

    userService.getCurrentUser().then(
      (userInfo: any) => {
        // Update localStorage
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
        // Update Redux
        dispatch(success(userInfo));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: userConstants.LOGIN_REQUEST };
  }
  function success(userInfo: any) {
    return { type: userConstants.LOGIN_SUCCESS, payload: userInfo };
  }
  function failure(error: any) {
    return { type: userConstants.LOGIN_FAILURE, payload: error };
  }
};

const loginSuccess = (userInfo: any) => {
  return { type: userConstants.LOGIN_SUCCESS, payload: userInfo };
};

const getAllTeachers = () => {
  return (dispatch: any) => {
    const request = () => {
      return { type: userConstants.GETALL_REQUEST };
    };
    const success = (teachers: any) => {
      return { type: userConstants.GETALL_SUCCESS, payload: teachers };
    };
    const failure = (errorObj: any) => {
      return { type: userConstants.GETALL_FAILURE, payload: errorObj };
    };

    try {
      userService.getAll().then(
        (teachers: any) => {
          dispatch(success(teachers));
        },
        (error: any) => {
          dispatch(failure(error.toString()));
          dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
        }
      );
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification('Error when GET_ALL_TEACHERS!', 'DANGER'));
    }
  }
};

const getAllStudents = () => {
  return (dispatch: any) => {
    const request = () => {
      return { type: userConstants.GETALL_REQUEST };
    };
    const success = (students: any) => {
      return { type: userConstants.GETALL_SUCCESS, payload: students };
    };
    const failure = (errorObj: any) => {
      return { type: userConstants.GETALL_FAILURE, payload: errorObj };
    };

    try {
      userService.getAllStudents().then(
        (students: any) => {
          dispatch(success(students));
        },
        (error: any) => {
          dispatch(failure(error.toString()));
          dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
        }
      );
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification('Error when GET_ALL_STUDENTS!', 'DANGER'));
    }
  }
};

const createUser = (user: any) => {
  return (dispatch: any) => {
    dispatch(request(user));

    userService.create(user).then(
      (newUser: any) => {
        dispatch(success(newUser));
        dispatch(notificationActions.addNotification('Create User Successfully!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request(user: any) {
    return { type: userConstants.CREATE_REQUEST, user };
  }
  function success(user: any) {
    return { type: userConstants.CREATE_SUCCESS, user };
  }
  function failure(error: any) {
    return { type: userConstants.CREATE_FAILURE, error };
  }
};

const updateUser = (user: any) => {
  return (dispatch: any) => {
    dispatch(request(user));

    userService.update(user).then(
      (updatedUser: any) => {
        dispatch(success(updatedUser));
        dispatch(notificationActions.addNotification('Update User Successfully!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request(user: any) {
    return { type: userConstants.UPDATE_REQUEST, user };
  }
  function success(user: any) {
    return { type: userConstants.UPDATE_SUCCESS, user };
  }
  function failure(error: any) {
    return { type: userConstants.UPDATE_FAILURE, error };
  }
};

const deleteUser = (id: number) => {
  return (dispatch: any) => {
    dispatch(request(id));

    userService.delete(id).then(
      () => {
        dispatch(success(id));
        dispatch(notificationActions.addNotification('Delete User Successfully!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(id, error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request(id: number) {
    return { type: userConstants.DELETE_REQUEST, id };
  }
  function success(id: number) {
    return { type: userConstants.DELETE_SUCCESS, id };
  }
  function failure(id: number, error: any) {
    return { type: userConstants.DELETE_FAILURE, id, error };
  }
};

const changeUserPassword = (userId: number, newPassword: string) => {
  return (dispatch: any) => {
    dispatch(request(userId));

    userService.updatePassword(userId, newPassword).then(
      () => {
        dispatch(success(userId));
        dispatch(notificationActions.addNotification('Password Changed Successfully!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(userId, error.toString()));
        dispatch(notificationActions.addNotification('Error: ' + error.toString(), 'DANGER'));
      }
    );
  };

  function request(userId: number) {
    return { type: userConstants.CHANGE_PASSWORD_REQUEST, userId };
  }
  function success(userId: number) {
    return { type: userConstants.CHANGE_PASSWORD_SUCCESS, userId };
  }
  function failure(userId: number, error: any) {
    return { type: userConstants.CHANGE_PASSWORD_FAILURE, userId, error };
  }
};

const updateUserAvatar = (avatarBase64: string) => {
  return (dispatch: any) => {
    dispatch(request());

    userService.uploadAvatar(avatarBase64).then(
      (response: any) => {
        console.log('uploadAvatar response:', response);
        console.log('response.avatar:', response?.avatar);
        console.log('response.avatar_url:', response?.avatar_url);
        
        // Get current user info from Redux/localStorage
        const userInfo = localStorage.getItem('userInfo');
        if (userInfo) {
          const user = JSON.parse(userInfo);
          console.log('Old user avatar:', user.avatar);
          // Update avatar from response (handle both avatar and avatar_url)
          const newAvatarPath = response?.avatar || response?.avatar_url;
          if (newAvatarPath) {
            user.avatar = newAvatarPath;
          }
          console.log('New user avatar:', user.avatar);
          localStorage.setItem('userInfo', JSON.stringify(user));
          console.log('Dispatching LOGIN_SUCCESS with user:', user);
          // Dispatch LOGIN_SUCCESS to update Redux with new avatar
          dispatch({ type: userConstants.LOGIN_SUCCESS, payload: user });
        }
        dispatch(notificationActions.addNotification('Avatar Updated Successfully!', 'SUCCESS'));
      },
      (error: any) => {
        console.error('uploadAvatar error:', error);
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification('Error: ' + error.toString(), 'DANGER'));
      }
    );
  };

  function request() {
    return { type: userConstants.UPDATE_REQUEST };
  }
  function failure(error: any) {
    return { type: userConstants.UPDATE_FAILURE, error };
  }
};

export const userActions = {
  login,
  loginSuccess,
  logout,
  signup,
  getAllTeachers,
  getAllStudents,
  getTeacherById,
  createUser,
  updateUser,
  deleteUser,
  changeUserPassword,
  updateUserAvatar
};
